var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.364 7.778L0 14.142l1.414 1.414 6.364-6.364 6.364 6.364 1.414-1.414-6.364-6.364 6.364-6.364L14.142 0 7.778 6.364 1.414 0 0 1.414l6.364 6.364z",
    fill: "#170F4F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgIGQ9Ik02LjM2Mzk2IDcuNzc4MTdMMCAxNC4xNDIxTDEuNDE0MjEgMTUuNTU2M0w3Ljc3ODE3IDkuMTkyMzlMMTQuMTQyMSAxNS41NTYzTDE1LjU1NjMgMTQuMTQyMUw5LjE5MjM5IDcuNzc4MTdMMTUuNTU2MyAxLjQxNDIxTDE0LjE0MjEgMEw3Ljc3ODE3IDYuMzYzOTZMMS40MTQyMSAwTDAgMS40MTQyMUw2LjM2Mzk2IDcuNzc4MTdaIgogICAgZmlsbD0iIzE3MEY0RiIgLz4KPC9zdmc+";
export { SvgIconClose as ReactComponent };